import { IndicatorIdTransfer }   from 'Component/IndicatorIdTransfer/IndicatorIdTransfer';
import { CustomSearchBarDrawer } from 'Container/CustomSearchBarDrawer/CustomSearchBarDrawer';
import React                     from 'react';

export const IndicatorId = (props) => (
  <CustomSearchBarDrawer {...props}>
    {({ value, onChange }) => <IndicatorIdTransfer value={value} onChange={onChange}/>}
  </CustomSearchBarDrawer>
);
